function roundToHundredth(x) {
  return Number(Math.round(x + "e+2") + "e-2");
}

export { roundToHundredth };
